import {
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Badge,
  Avatar,
  Image,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Tokens from "./Tokens";
import Leaderboard from "./LeaderBoard";
import Login from "./Login";
import { Toaster } from "react-hot-toast";
import User from "./User";
import Orders from "./Orders";
import Dashboard from "./Dashboard";
import StakingLeaderboard from "./StackingLeaderboard";
import Fees from "./Fees";
import FeeTransactions from "./FeeTransactions";

function Navbar() {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  const navButtonProps = (path: string) => ({
    as: Link,
    to: path,
    variant: "ghost",
    size: "sm",
    color: isActive(path) ? "white" : "gray.300",
    bg: isActive(path) ? "brand.600" : "transparent",
    _hover: {
      bg: isActive(path) ? "brand.700" : "gray.700",
      color: "white",
    },
    _active: {
      bg: isActive(path) ? "brand.800" : "gray.600",
    },
    borderRadius: "8px",
    fontWeight: isActive(path) ? "600" : "400",
    position: "relative" as const,
  });
  return (
    <Box 
      bg="gray.800" 
      borderBottom="1px solid" 
      borderColor="gray.700" 
      px={6} 
      py={4}
      position="sticky"
      top={0}
      zIndex={1000}
      backdropFilter="blur(10px)"
      boxShadow="sm"
    >
      <Flex
        h={12}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Logo/Brand */}
        <Flex alignItems="center" gap={3}>
          <Image 
          src="data:image/png;base64,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"
            alt="PerpX Logo"
            height="32px"
            width="auto"
            objectFit="contain"
          />
          <Badge 
            colorScheme="blue" 
            variant="subtle"
            fontSize="xs"
            px={2}
            py={1}
            borderRadius="full"
          >
            Admin
          </Badge>
        </Flex>

        {/* Desktop Navigation */}
        <Flex
          alignItems="center"
          gap={1}
          display={{ base: "none", lg: "flex" }}
        >
          <Button {...navButtonProps("/dashboard")}>
            Dashboard
          </Button>
          <Button {...navButtonProps("/tokens")}>
            Tokens
          </Button>
          <Button {...navButtonProps("/leaderboard")}>
            Leaderboard
          </Button>
          <Button {...navButtonProps("/user")}>
            Users
          </Button>
          <Button {...navButtonProps("/order")}>
            Orders
          </Button>
          <Button {...navButtonProps("/staking-leaderboard")}>
            Staking
          </Button>
          <Button {...navButtonProps("/fees")}>
            Fees
          </Button>
          <Button {...navButtonProps("/fee-transactions")}>
            Fee Transactions
          </Button>
        </Flex>

        {/* User Menu and Logout */}
        <Flex alignItems="center" gap={3}>
          <Avatar size="sm" name="Admin" bg="brand.600" />
          <Button
            size="sm"
            variant="outline"
            borderColor="red.600"
            color="red.400"
            _hover={{
              bg: "red.600",
              color: "white",
              borderColor: "red.600",
            }}
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Logout
          </Button>
        </Flex>

        {/* Mobile Navigation (Hamburger Menu) */}
        <Box display={{ base: "block", lg: "none" }}>
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="outline"
              borderColor="gray.600"
              color="gray.300"
              _hover={{
                bg: "gray.700",
                borderColor: "gray.500",
              }}
            />
            <MenuList bg="gray.800" borderColor="gray.700">
              <MenuItem 
                as={Link} 
                to="/dashboard"
                _hover={{ bg: "gray.700" }}
                color={isActive("/dashboard") ? "brand.400" : "gray.300"}
                bg={isActive("/dashboard") ? "brand.900" : "transparent"}
              >
                Dashboard
              </MenuItem>
              <MenuItem 
                as={Link} 
                to="/tokens"
                _hover={{ bg: "gray.700" }}
                color={isActive("/tokens") ? "brand.400" : "gray.300"}
                bg={isActive("/tokens") ? "brand.900" : "transparent"}
              >
                Tokens
              </MenuItem>
              <MenuItem 
                as={Link} 
                to="/leaderboard"
                _hover={{ bg: "gray.700" }}
                color={isActive("/leaderboard") ? "brand.400" : "gray.300"}
                bg={isActive("/leaderboard") ? "brand.900" : "transparent"}
              >
                Leaderboard
              </MenuItem>
              <MenuItem 
                as={Link} 
                to="/user"
                _hover={{ bg: "gray.700" }}
                color={isActive("/user") ? "brand.400" : "gray.300"}
                bg={isActive("/user") ? "brand.900" : "transparent"}
              >
                Users
              </MenuItem>
              <MenuItem 
                as={Link} 
                to="/order"
                _hover={{ bg: "gray.700" }}
                color={isActive("/order") ? "brand.400" : "gray.300"}
                bg={isActive("/order") ? "brand.900" : "transparent"}
              >
                Orders
              </MenuItem>
              <MenuItem
                as={Link}
                to="/staking-leaderboard"
                _hover={{ bg: "gray.700" }}
                color={isActive("/staking-leaderboard") ? "brand.400" : "gray.300"}
                bg={isActive("/staking-leaderboard") ? "brand.900" : "transparent"}
              >
                Staking & Leaderboard
              </MenuItem>
              <MenuItem
                as={Link}
                to="/fees"
                _hover={{ bg: "gray.700" }}
                color={isActive("/fees") ? "brand.400" : "gray.300"}
                bg={isActive("/fees") ? "brand.900" : "transparent"}
              >
                Fees
              </MenuItem>
              <MenuItem
                as={Link}
                to="/fee-transactions"
                _hover={{ bg: "gray.700" }}
                color={isActive("/fee-transactions") ? "brand.400" : "gray.300"}
                bg={isActive("/fee-transactions") ? "brand.900" : "transparent"}
              >
                Fee Transactions
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.location.href = "/";
                }}
                _hover={{ bg: "red.600" }}
                color="red.400"
              >
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </Flex>
    </Box>
  );
}

function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/";

  return (
    <Box minH="100vh" bg="gray.900">
      {!hideNavbar && <Navbar />}
      <Box minH={hideNavbar ? "100vh" : "calc(100vh - 80px)"}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/user" element={<User />} />
          <Route path="/order" element={<Orders />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/staking-leaderboard" element={<StakingLeaderboard />} />
          <Route path="/stacking-leaderboard" element={<StakingLeaderboard />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/fee-transactions" element={<FeeTransactions />} />
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <AppContent />
    </Router>
  );
}

export default App;
